angular.module('leanlaw.core').factory('clientMatterOptionsService', ['$http', 'leanLawAuth', function ($http, leanLawAuth) {
  const state = {
    domain: `${leanLawAuth.domain}/v1`
  };
  async function listClientOptions(query) {
    const path = `${state.domain}/clients/options`;
    return $http.get(path, {
      params: query
    }).then(response => response.data);
  }
  async function getClient(clientId) {
    const path = `${state.domain}/clients/option`;
    return $http.get(path, {
      params: {
        clientId
      }
    }).then(response => response.data);
  }
  async function getMatter(matterId) {
    const path = `${state.domain}/matters/option`;
    return $http.get(path, {
      params: {
        matterId
      }
    }).then(response => response.data);
  }
  async function getClientCount(query) {
    const path = `${state.domain}/clients/optionscount`;
    return $http.get(path, {
      params: query
    }).then(response => response.data);
  }
  async function listMatterOptions(query) {
    const path = `${state.domain}/matters/options`;
    return $http.get(path, {
      params: query
    }).then(response => response.data);
  }
  async function getMatterCount(query) {
    const path = `${state.domain}/matters/optionscount`;
    return $http.get(path, {
      params: query
    }).then(response => response.data);
  }
  return {
    listClientOptions,
    listMatterOptions,
    getClientCount,
    getMatterCount,
    getClient,
    getMatter,
    state
  };
}]);